import { gql } from '__generated__';

export const TicketNumberSequenceAttributesFragment = gql(`
  fragment TicketNumberSequenceAttributes on TicketNumberSequence {
    id
    event {
      id
    }
    title
    start_number
    prefix
    suffix
    example
    start_time
    corral_name
    capacity
    locked
    manual_ticket_numbers
    filters {
      ...RegistrationFilters
    }
    scanner {
      id
      title
    }
    assigned_ticket_number_count
    potential_ticket_number_count
    locked_ticket_number_count
  }
`);

export default gql(`
  query GetTicketNumberSequence($project_id: ID!, $ticket_number_sequence_id: ID!) {
    project(id: $project_id) {
      id
      ticket_number_sequence(id: $ticket_number_sequence_id) {
        ...TicketNumberSequenceAttributes
      }
    }
  }
`);
